import Axios from './Axios';

const reportError = async (errorData) => {
    try {
        const payload = {
            error: errorData.error,
            url: window.location.href,
            user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
            context: {
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString(),
                ...errorData.context
            }
        };

        await Axios.post('/error-report', payload);
    } catch (err) {
        // Silent fail to avoid infinite error loops
        console.error('Failed to report error:', err);
    }
};

export const initErrorReporting = () => {
    window.onerror = (message, source, lineno, colno, error) => {
        reportError({
            error: {
                message,
                source,
                lineno,
                colno,
                stack: error ? error.stack : null
            },
            context: { type: 'global_error' }
        });
        return false; // Let browser process it as well
    };

    window.onunhandledrejection = (event) => {
        reportError({
            error: {
                message: event.reason ? event.reason.message : 'Unhandled Promise Rejection',
                reason: event.reason,
                stack: event.reason ? event.reason.stack : null
            },
            context: { type: 'unhandled_rejection' }
        });
    };
};

export default reportError;
